import React from 'react';

import {
  Grid,
  Button,
  Typography,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const searchIDForm = (props) => {
  const buttons = (
    <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
      Search
    </Button>
  );

  return (
    <React.Fragment>
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="profile_id"
            config={props.inputs.profile_id}
            changed={event => props.inputChangedHandler(event, 'profile_id')}
          />
          <br />
          <Typography>You can search multiple IDs using comma separation (B1, G2)</Typography>
        </Grid>
      </Grid>
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default searchIDForm;



// WEBPACK FOOTER //
// ./src/search/components/IDForm.js